import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './style.scss';
import { SMALL, VERY_SMALL } from '../../constants/paragraphSizes';

export const P = (props) => {
  const { children, className, innerRef, size, ...rest } = props;

  const classNames = classnames(
    {
      [styles.paragraph]: true,
      [styles['paragraph--small']]: size === SMALL,
      [styles['paragraph--very-small']]: size === VERY_SMALL,
    },
    className,
  );
  return (
    <p ref={innerRef} className={classNames} {...rest}>
      {children}
    </p>
  );
};

P.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
  ]).isRequired,
  className: PropTypes.string,
  innerRef: PropTypes.func,
  size: PropTypes.string,
};

P.defaultProps = {
  className: undefined,
  innerRef: () => {},
  size: '',
};

export default React.memo(P);
